import {ACTION_CODE} from './_actionCode';
import {ExpenseService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_ALL_EXPENSES';

export async function getAllExpenses(
    userData: Record<string, string>,
    before: string,
    after: string,
    optionalProps?: Record<string, string>,
    query = ''
) {
    try {
        LoggerService.logInfo('Action - getAllExpenses - Start');

        const getAllExpensesResult = await ExpenseService.getAllExpenses(userData, before, after, optionalProps, query);

        const {data, metadata} = getAllExpensesResult;

        LoggerService.logInfo('Action - getAllExpenses - End - Success');

        return ResultModel.newSuccessResult(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllExpenses - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des frais .',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
